module.exports = __webpack_public_path__ + "static/img/6.234d780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/6.png
// module id = Ipes
// module chunks = 0